import { render, staticRenderFns } from "./DeleteAllObjectivesModal.vue?vue&type=template&id=d242b196"
import script from "./DeleteAllObjectivesModal.vue?vue&type=script&lang=js"
export * from "./DeleteAllObjectivesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports